import type {
  ContentObject,
  ContentTypeDefinition,
  Media,
  MediaHydrated,
  WithOptionalInternalProps,
} from '../lib/flotiq-client/types/api-response';

import { createContext } from 'react';

export type VariantCreateFn = (
  media?: Media | MediaHydrated,
) => Promise<[null, boolean]>;

export type VariantDeleteFn = (
  media?: Media | MediaHydrated,
  idx?: number,
) => Promise<[null, boolean]>;

export interface ContentObjectFormContextProps {
  contentType?: WithOptionalInternalProps<ContentTypeDefinition> | null;
  isEditing?: boolean;
  initialData?: WithOptionalInternalProps<ContentObject> | null;
  onVariantCreate?: VariantCreateFn;
  onVariantDelete?: VariantDeleteFn;
  isPatchable?: boolean;
  overriddenFields?: Record<string, boolean>;
  setOverriddenFields?: (checked: boolean, fieldName: string) => void;
  isSaving?: boolean;
  editedCount?: number;
  formUniqueKey?: string;
}

export const ContentObjectFormContext =
  createContext<ContentObjectFormContextProps>({});

export default ContentObjectFormContext;
